import { render } from "./CustomBlock.vue?vue&type=template&id=e7d639a6&scoped=true"
import script from "./CustomBlock.vue?vue&type=script&lang=js"
export * from "./CustomBlock.vue?vue&type=script&lang=js"

import "./CustomBlock.vue?vue&type=style&index=0&id=e7d639a6&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d639a6"]])

export default __exports__